import React from 'react';
import h from './img/20.png';
import hh from './img/21.jpeg';
import hhh from './img/22.jpg';
import hhhh from './img/23.jpeg';
import hhhhh from './img/24.jpeg';
import hhhhhh from './img/25.png';
import hhhhhhh from './img/26.png';
import hhhhhhhh from './img/27.jpeg';
import hhhhhhhhh from './img/28.jpeg';
import hhhhhhhhhh from './img/29.png';
import hhhhhhhhhhh from './img/30.png';
import hhhhhhhhhhhh from './img/31.jpeg';
import hhhhhhhhhhhhh from './img/32.jpeg';

import './customers.css';


const images = [
  h,
  hhhhhhhhhhh,
  hhh,
  hhhh,
  hhhhhhhhhhhhh,
  hhhhhhh,
  hhhhhhhhhhhh,
  hhhhhh,
  hh,
  hhhhhhhh,
  hhhhhhhhhhhh,
  hhhhhhhhh,
  hhhhh
];


// =====================================================
// חלוקה ל-2 שורות
// =====================================================

const row1 = images.slice(0, 7);
const row2 = images.slice(7);


// =====================================================
// MARQUEE ROW
// =====================================================

const MarqueeRow = ({ images, reverse = false, row }) => {

  return (
    <div className={`marquee-container marquee-row-${row}`}>

      <div
        className={`marquee-content ${
          reverse ? 'marquee-reverse' : ''
        }`}
      >

        {/* התמונות המקוריות */}
        {images.map((imgSrc, index) => (

          <div
            className="marquee-item"
            key={`row-${row}-${index}`}
          >

            <img
              src={imgSrc}
              className="customer-img"
              alt={`לקוח ${index + 1}`}
              loading="lazy"
              draggable="false"
            />

          </div>

        ))}


        {/* שכפול לגלילה רציפה */}
        {images.map((imgSrc, index) => (

          <div
            className="marquee-item"
            key={`row-${row}-copy-${index}`}
            aria-hidden="true"
          >

            <img
              src={imgSrc}
              className="customer-img"
              alt=""
              loading="lazy"
              draggable="false"
            />

          </div>

        ))}

      </div>

    </div>
  );
};


// =====================================================
// CUSTOMERS
// =====================================================

export const customers = () => {

  return (

    <section className="customers-section">

      {/* ================================================
          שורה 1
          7 תמונות
      ================================================= */}

      <MarqueeRow
        images={row1}
        row="one"
      />


      {/* ================================================
          שורה 2
          6 תמונות
          תנועה הפוכה
      ================================================= */}

      <MarqueeRow
        images={row2}
        reverse
        row="two"
      />

    </section>

  );
};
